import {
    Directive,
    Input,
    AfterViewInit,
    OnChanges,
    SimpleChanges
} from '@angular/core';


@Directive({
    standalone: true,
    selector: '[scrollIntoView]'
})
export class ScrollIntoView
    implements AfterViewInit, OnChanges
{

    @Input('scrollIntoView') trigger?: unknown;

    ngAfterViewInit() {
        this.doScroll();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['trigger'] && !changes['trigger'].firstChange) {
            this.doScroll();
        }
    }

    private doScroll() {
        globalThis.setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 0);
    }
}